module.exports = __webpack_public_path__ + "bin/3e32a009f4a8304e4ed0fc5c27c55a06.png";